import { render, staticRenderFns } from "./MyImageView.vue?vue&type=template&id=20600862&"
import script from "./MyImageView.vue?vue&type=script&lang=js&"
export * from "./MyImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports